// extracted by mini-css-extract-plugin
module.exports = {"carousel":"skeleton-carousel_carousel__BEgeH","initialSlide":"skeleton-carousel_initialSlide__AOV8G"};